//
// UserInfo.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "./particles/Capability";
import "@sas-dvr/ltjs-commons/models/particles/Link";

var UserInfo = createModule("transport::UserInfo", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        capabilities: [4],
        userDisplayName: 7,
        links: [1],
        userId: 7,
        memberships: [7],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default UserInfo;
